import { ref } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import useClient from '../client/apiClient'

export default function useTCamiones() {
  const tcamion = ref([])
  const tcamiones = ref([])
  const tipoTCamiones = ref([])
  const tcamionesDelete = ref([])

  const client = useClient()

  const dt = ref({})
  const loading = ref(false)
  const saving = ref(false)

  const selectedTCamiones = ref()
  const deleteTCamionesDialog = ref(false)
  const deleteTCamionDialog = ref(false)
  const tcamionDialog = ref(false)
  const submitted = ref(false)
  const tipos_carga = ref(['C', 'CC'])
  const filteredTipo = ref()

  const getCRUD = async () => {
    loading.value = true
    client.get(`/api/tcamiones/all/crud`).then(response => {
      tcamiones.value = response.data.data.tcamiones
      tipoTCamiones.value = response.data.data.tcamiones
      loading.value = false
    })
  }

  const storeTCamion = async (form) => {
    saving.value = true
    let id = tcamion.value.id
    if (id) {
      //Esta editando el registro
      client.put(`/api/tcamiones/${id}`, { 'data': { ...form } })
        .then(() => {
          saving.value = !saving.value
          tcamionDialog.value = false
          getCRUD()
        })
    } else {
      //Esta creando el registro
      client.post(`/api/tcamiones`, { 'data': { ...form } })
        .then(() => {
          tcamionDialog.value = client.dialog.value
          tcamion.value = client.entity.value
          saving.value = client.saving.value
          getCRUD()
        })
    }
  }

  const deleteTCamion = async () => {
    client.remove(`/api/tcamiones/${tcamion.value.id}`)
      .then(response => {
        tcamiones.value = tcamiones.value.filter(val => val.id !== tcamion.value.id)
        deleteTCamionDialog.value = false
        tcamion.value = {}
      })
  }

  const deleteSelecteds = async () => {
    tcamionesDelete.value = selectedTCamiones.value.map(({ id }) => id)
    client.remove(`/api/tcamiones/destroy/mass`, { data: tcamionesDelete.value })
      .then(response => {
        tcamiones.value = tcamiones.value.filter(
          (val) => !selectedTCamiones.value.includes(val)
        )
        deleteTCamionesDialog.value = false
        selectedTCamiones.value = null
        tcamionesDelete.value = null
      })
  }

  const filters = ref({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  return {
    tcamion,
    tcamiones,
    tipos_carga,
    dt,
    loading,
    saving,
    filters,
    selectedTCamiones,
    deleteTCamionesDialog,
    deleteTCamionDialog,
    tcamionDialog,
    submitted,
    filteredTipo,
    deleteSelecteds,
    getCRUD,
    storeTCamion,
    deleteTCamion
  }
}